import { SESSION_KEY } from './constants.js';

// ─── PERSISTED SESSION ────────────────────────────────────────────────────────
// One reader for the staff/vendor session blob, so expiry semantics live in a
// single place. AdminLogin persists role/name/email alongside the tokens; the
// catalogue route reads them to detect impersonation without a round-trip.
export function readSession() {
  try {
    const s = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
    if (!s?.access_token) return null;
    if (s.expires_at && Date.now() > s.expires_at) return null; // dead session
    return s;
  } catch { return null; }
}

// Impersonation ("View as customer") is super-admin only: it exposes a
// customer's pricing, order history and cart, and stamps on-behalf-of
// attribution on orders. Mirrored server-side by is_super_admin() in the
// admin_impersonation_log policies — this check only decides what to render.
export function isSuperAdminSession() {
  return readSession()?.role === 'super_admin';
}
